import { render, staticRenderFns } from "./params.vue?vue&type=template&id=7f9ce4cd&"
import script from "./params.vue?vue&type=script&lang=ts&"
export * from "./params.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports